module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_rushing_yds/green-b5fd3775e0706d0239f1a57d3b19201d.svg";